module.exports = __webpack_public_path__ + "static/media/capitalOne.4104a98b.svg";